<template>
  <b-card
    no-body
    :class="[{'open': visible}, 'queue-services']"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-img
      v-if="service.image"
      :src="service.image"
      alt="Image"
      top
      @click="updateVisible(!visible)"
    />
    <b-card-header
      :class="[{'collapsed': !visible}, 'queue-card-header']"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible)"
    >
      <b-container class="bv-example-row">
        <b-row align-h="between">
          <span
            cols="9"
            align="start"
            name="header"
            class="col justify-content-start"
          >
            <b-col class="col justify-content-start pl-0 pr-0">
              <span class="lead collapse-title queue-bloc-title">{{ service.name }}</span><br>
              <small class="text-secondary">{{ service.description }}</small>
            </b-col>
          </span>
          <b-col
            cols="3"
            align="center"
            class="p-0 d-flex align-items-center justify-content-center"
          >
            <b-badge
              :style="{backgroundColor: getWidgetSettings.main_color}"
              pill
              class="mt-1 mr-1 mb-1 badge-round"
            >
             {{ getWidgetSettings.currency }} {{ service.price }}
            </b-badge>
          </b-col>
        </b-row>
      </b-container>
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <b-card-body class="collapse-pb" v-if="visible">
        <!-- if service don't have any specialist-->
        <div
          v-if="showWorkspacesThisService(service.workspaces_by_service).length === 0 && !getErrorWorkspaceStatus"
          class="text-center queue-dont-have-specialist"
        >
          <small>
            {{ i18n.t('free-service-1') }}<br>
            {{ i18n.t('free-service-2') }}
            <b-link :style="{color: getWidgetSettings.main_color}">
              {{ getWidgetSettings.phone }}
            </b-link>
          </small>
        </div>
        <!-- error-->
        <div
          v-if="getWorkspaces.length === 0 && getErrorWorkspaceStatus"
          class="text-center queue-dont-have-specialist"
        >
          <small class="text-danger">
            {{ i18n.t('error.something_wrong') }}
          </small>
        </div>
        <!-- specialists-->
        <specialist-with-timeslots
          v-for="(workspace, index) in showWorkspacesThisService(service.workspaces_by_service)"
          v-else
          :key="index"
          :workspace="workspace"
          :service="service.id"
          :main-color="getWidgetSettings.main_color"
          margin="queue-margin"
          @openForm="showForm"
        />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import {
  BCard, BContainer, BCardHeader, BCollapse, BRow, BCol, BBadge, BLink, BCardBody, BCardImg,
} from 'bootstrap-vue'
import i18n from '@/libs/i18n'
import { mapGetters } from 'vuex'
import SpecialistWithTimeslots from '@/components/booking/SpecialistWithTimeslots.vue'
  export default {
  props: {
    service: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
      required: true,
    },
  },
  components: {
    BCard, BContainer, BCardHeader, BCollapse, BRow, BCol, BBadge, BLink, BCardBody, BCardImg, SpecialistWithTimeslots,
  },
  data() {
    return {
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
      i18n,
    }
  },
  computed: {
    ...mapGetters(['getWidgetSettings', 'getWorkspaces', 'getErrorWorkspaceStatus']),
    accordion() {
      return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null
    },
  },
  created() {
    this.collapseItemID = uuidv4()
  },
  methods: {
    showForm(val) {
      this.$emit('openForm', { timeslot: val.timeslot, day: val.day, service: this.service, workspace: val.workspace })
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true)
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false)
    },
    updateVisible(val = true) {
      // if (val === true) {
      //   this.$emit('loadRecords')
      // }
      this.visible = val
      // this.$emit('visible', val)
    },
    showWorkspacesThisService(workspaces) {
      const answer = []
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < workspaces.length; i++) {
        const workspace = this.getWorkspaces.find(item => item.id === workspaces[i])
        if (workspace !== undefined) {
          answer.push(workspace)
        }
      }
      return answer
    },
  }
  }
</script>
<style>

</style>
